var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import nemWrapper from '../../../ts/nemWrapper';
import walletModel from '../../../ts/walletModel';
import ConfirmationModal from './../ConfirmationModal.vue';
// コンポーネントの設定
var MyWalletInfo = /** @class */ (function (_super) {
    __extends(MyWalletInfo, _super);
    function MyWalletInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wallet = new walletModel();
        _this.qrSize = 200;
        return _this;
    }
    MyWalletInfo.prototype.openModalInfo = function () {
        this.$data.info_modal = true;
    };
    MyWalletInfo.prototype.openModalSingUp = function () {
        this.$data.signup_modal = true;
    };
    MyWalletInfo.prototype.closeModal = function () {
        this.$data.info_modal = false;
        this.$data.signup_modal = false;
    };
    MyWalletInfo = __decorate([
        Component({
            name: 'my_wallet_info',
            methods: {},
            data: function () { return ({
                nem: new nemWrapper(),
                title: "あなたのアドレス",
                info_modal: false,
                signup_modal: false,
                qrJson: '',
            }); },
            components: { ConfirmationModal: ConfirmationModal }
        })
    ], MyWalletInfo);
    return MyWalletInfo;
}(Vue));
export default MyWalletInfo;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/details/MyWalletInfo.vue
// module id = 262
// module chunks = 1